// [A2] 機構 features 開關 —— 前端共用工具
//
// 與後端 app/core/institution_features.py 的 DEFAULT_FEATURES 對應。真正的存取控制一律在
// 後端做（前端 gating 只是「不要讓使用者看到用不到的入口」，不是安全邊界）。
export const DEFAULT_FEATURES = {
    pickup: true,
    comm_book: true,
    leaves: true,
    lunch: true,
    makeup: true,
    announcements: true,
    chat: true,
    car_plate: false,
    simple_pickup: false,
};

/**
 * 家長名下孩子可能分屬不同機構（跨機構家庭，例如安親哥哥 + 幼稚園妹妹）。導航/入口要
 * 「只要有一個孩子的機構開了這個功能，就顯示」（聯集），不是「全部孩子都要開」（交集）——
 * 入口只是導頁，個別頁面本來就會依各自孩子的資料顯示，不會因為顯示了入口就對沒有該
 * 功能的孩子造成任何影響。
 *
 * children 為 undefined/空陣列時（尚未載入、或帳號還沒綁定孩子）刻意 fallback 回全開，
 * 不要比預設更保守——避免資料載入中那一瞬間閃過「入口消失」。
 */
export function getUnionFeatures(children) {
    const union = { ...DEFAULT_FEATURES };
    if (!children || children.length === 0) {
        return union;
    }
    Object.keys(union).forEach((key) => {
        union[key] = false;
    });
    children.forEach((child) => {
        const f = (child && child.institution && child.institution.features) || DEFAULT_FEATURES;
        Object.keys(union).forEach((key) => {
            if (f[key]) union[key] = true;
        });
    });
    return union;
}

/** 單一孩子是否屬於「簡化接送」機構（features.simple_pickup=true）。 */
export function isSimplePickupChild(child) {
    const f = (child && child.institution && child.institution.features) || DEFAULT_FEATURES;
    return !!f.simple_pickup;
}

/** [A3] 單一孩子是否屬於「開放車號」機構（features.car_plate=true）。 */
export function isCarPlateChild(child) {
    const f = (child && child.institution && child.institution.features) || DEFAULT_FEATURES;
    return !!f.car_plate;
}

/** [B3] 單一孩子是否屬於「開放親師對話」機構（features.chat=true）。
 * 與伺服器旗標 chat_enabled（useChatEnabled）是兩層獨立開關：後者是全域休眠總開關，
 * 這個是機構層級（例如幼稚園可能不開 chat，即使全域旗標已開）。兩者都要通過對話才會顯示。 */
export function isChatChild(child) {
    const f = (child && child.institution && child.institution.features) || DEFAULT_FEATURES;
    return !!f.chat;
}
